module.exports = __webpack_public_path__ + "img/video_bttom_bg.94edf38c.png";